import { validationErrorLabelMap } from "../../../../../../utils/utils/get-validation-error-codes.js";
const getConfirmationModalLabels = (getFormattedLabel, getLabel, validation, lineItems) => {
  let title, sanitizationAction;
  const { action, lineItemId } = validation.validationError.actionItem;
  const actionKey = action.toLowerCase();
  const validationErrorCode = validationErrorLabelMap[validation.validationError.validationCode];
  const conflictingProductType = lineItems?.find((lineItem) => lineItem.id === lineItemId)?.displayType || "";
  if (validation.singleValidation && conflictingProductType) {
    title = getLabel(`cart.sanitizationAction.${actionKey}.title`);
    sanitizationAction = getFormattedLabel(`cart.sanitizationAction.actionDescription`, {
      labelData: { action: actionKey, productType: conflictingProductType }
    });
  } else {
    title = getLabel(`cart.sanitizationAction.${actionKey}.title.plural`);
    sanitizationAction = getFormattedLabel(`cart.sanitizationAction.actionDescription.generic`, {
      labelData: { action: actionKey }
    });
  }
  return {
    title,
    errorMessage: getLabel(`cart.${validationErrorCode}`),
    sanitizationAction,
    actionButton: getLabel(`cart.sanitizationAction.confirm`),
    cancelButton: getLabel(`cart.sanitizationAction.cancel`)
  };
};
export {
  getConfirmationModalLabels
};
//# sourceMappingURL=get-confirmation-modal-labels.js.map
